<template>
  <ul class="grid-standard mt-24 !gap-y-20">
    <li
      v-for="marketCountryCode in markets"
      :key="marketCountryCode"
      class="flex items-center md:col-span-2 lg:col-span-3"
    >
      <IconCheckInCircle
        v-if="withActiveMarkets"
        class="text-action-success-hi mr-12"
      />

      <Flag class="mr-8" :country-code="marketCountryCode" size="m" />

      <span class="body-1">
        {{ i18n.country(marketCountryCode) }}
      </span>
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { MarketCountryCode } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconCheckInCircle } from '@ds/icons/IconCheckInCircle'

const i18n = useI18n()

defineProps<{
  withActiveMarkets?: boolean
  markets: MarketCountryCode[]
}>()
</script>
